import { Blueprint } from '../../blueprint.class';
import { ToolResult } from '../../types';

export interface GetAppliancesArgs {
	category?: string;
}

export interface ApplianceInfo {
	sku: string;
	name: string;
	dimensions: {
		width: number;
		height: number;
		depth: number;
	} | null;
}

export const getAppliancesTool = (blueprint: Blueprint, { category }: GetAppliancesArgs): ToolResult<ApplianceInfo[]> => {
	// Filter components by category ID if provided
	const filtered = category
		? blueprint.context.components.filter((c) => c.category?.id === category)
		: blueprint.context.components;

	const appliances: ApplianceInfo[] = filtered.map((c) => ({
		sku: c.sku,
		name: c.description,
		dimensions: c.size ? {
			width: c.size.width,
			height: c.size.height,
			depth: c.size.depth
		} : null
	}));

	if (appliances.length === 0) {
		return {
			success: false,
			error: category
				? `Category '${category}' not found or has no appliances. Use get_appliance_categories to get valid category keys.`
				: 'No appliances found.'
		};
	}

	return {
		success: true,
		message: `Found ${appliances.length} appliances${category ? ` in category '${category}'` : ''}.`,
		data: appliances
	};
};
